"use strict";

var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

function Exception(/* message */) {
  var tmp = Error.prototype.constructor.apply(this, arguments);

  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
  for (var idx = 0; idx < errorProps.length; idx++) {
    this[errorProps[idx]] = tmp[errorProps[idx]];
  }
}

Exception.prototype = new Error();

exports["default"] = Exception;


//////////////////
// WEBPACK FOOTER
// ./~/handlebars/dist/cjs/handlebars/exception.js
// module id = 38
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21